import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import axios from "./plugins/axios";
import VueAxios from "vue-axios";
import VueCookies from "vue3-cookies";
import { useCookies } from "vue3-cookies";
import staticValue from "./utils/static";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import VueApexCharts from "vue3-apexcharts";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import "primeicons/primeicons.css";
import "./index.css";
import { VueReCaptcha } from 'vue-recaptcha-v3'
store.cookies = useCookies().cookies;
store.axios = axios;
store.router = router;
store.str = staticValue;

loadFonts();
createApp(App)
  .use(VueCookies, {
    expireTimes: "30d",
    path: "/",
    domain: "",
    secure: true,
    sameSite: "None",
  })
  .component("apexchart", VueApexCharts)
  .use(VueAxios, axios)
  .use(router)
  .use(store)
  .use(vuetify)
  .use(VueSweetalert2)
  .use(PrimeVue, {
    theme: {
        preset: Aura,
          options: {
            darkModeSelector: '',
        }
    }
})
.use(VueReCaptcha, { siteKey: '6LeqlTQqAAAAAKgVJvjAuR3x_Y6oP7rRrzO8paSq' })
  .component("Datepicker", Datepicker)
  .mount("#app");
